/**
 * Elevation probe interface used by simLite simulation.
 * Consumers must call `setElevationProbe` before running simulations
 * that involve GPS_ABOVE_GROUND_LEVEL waypoints.
 */
export interface ElevationProbe {
  getElevation: (lng: number, lat: number) => Promise<number>;
}

let elevationProbe: ElevationProbe | null = null;

/**
 * Set the elevation probe instance used by the simulation.
 * Must be called by the consuming application (e.g. customer portal)
 * before simulating missions with GPS_ABOVE_GROUND_LEVEL waypoints.
 */
export function setElevationProbe(probe: ElevationProbe): void {
  elevationProbe = probe;
}

/**
 * Returns the configured elevation probe.
 * Throws if no probe has been set.
 */
export function getElevationProbe(): ElevationProbe {
  if (!elevationProbe) {
    throw new Error(
      "Elevation probe not configured. Call setElevationProbe() before simulating missions with GPS_ABOVE_GROUND_LEVEL waypoints."
    );
  }
  return elevationProbe;
}
